var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 17,
    viewBox: "0 0 15 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.248959 9.80929L7.33272 16.8966C7.39931 16.9632 7.48922 17 7.58339 17C7.67755 17 7.7675 16.9625 7.83405 16.8959L14.8966 9.80929C14.9979 9.70802 15.0276 9.5558 14.9731 9.42337C14.9179 9.29096 14.789 9.20526 14.6459 9.20526L10.7514 9.20526L10.7514 0.354058C10.7514 0.158624 10.5928 -6.13324e-07 10.3974 -6.3041e-07L4.7326 -1.12564e-06C4.53716 -1.14273e-06 4.37854 0.158623 4.37854 0.354057L4.37854 9.2053L0.498895 9.20529C0.355871 9.20529 0.226986 9.29169 0.171754 9.4241C0.116523 9.5565 0.147691 9.70802 0.248959 9.80929Z",
    fill: "#DE5F85"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDown);
export default __webpack_public_path__ + "static/media/Down.ddc3ff5d2a7f5876f526822946dc481f.svg";
export { ForwardRef as ReactComponent };